import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/Okkanti/Okkanti/node_modules/next/dist/client/app-dir/link.js");
